/** Normaliza nombre de puesto para comparar. */
function normalizarPuesto(valor) {
  return String(valor || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toLowerCase()
}

/** Puesto exacto "Calidad" (toma de asistencia). No incluye Auditor/Analista de calidad. */
export function esPuestoCalidad(usuarioOPuesto) {
  if (usuarioOPuesto == null) return false

  if (typeof usuarioOPuesto === 'object') {
    const nombre = normalizarPuesto(
      usuarioOPuesto.puesto || usuarioOPuesto.nombre_puesto || ''
    )
    return nombre === 'calidad'
  }

  return normalizarPuesto(usuarioOPuesto) === 'calidad'
}

/**
 * Fallback UI: menú ya filtrado solo con Toma de asistencia de calidad.
 * Útil si el nombre de puesto no llegó en sesión pero el API sí filtró.
 */
export function menuSoloCalidad(menu) {
  if (!Array.isArray(menu) || !menu.length) return false

  const paths = []
  for (const m of menu) {
    const items = Array.isArray(m.items) ? m.items : []
    for (const item of items) {
      if (Array.isArray(item.items) && item.items.length) {
        for (const child of item.items) {
          if (child && child.path) paths.push(String(child.path))
        }
      } else if (item && item.path) {
        paths.push(String(item.path))
      }
    }
  }

  return paths.length > 0 && paths.every((p) => p === 'TomaAsistenciaCalidad')
}

export const RUTAS_PUESTO_CALIDAD = ['TomaAsistenciaCalidad', 'Home', 'Login']
